import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SpinnerComponent } from './spinner.component';

@NgModule({
  declarations: [ SpinnerComponent ],
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule
  ],
  exports: [
    SpinnerComponent
  ]
})
export class SpinnerModule { }